var Iframe_default = {
  "iframe": "_6CpWi"
};
export {
  Iframe_default as default
};
//# sourceMappingURL=Iframe-scss.js.map
